import { createContext, useContext, useState } from "react";
import SupportCenterModal from "../components/SupportCenterModal";

const SupportCenterContext = createContext(null);

export const SupportCenterProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("support");

  const openSupport = () => {
    setMode("support");
    setIsOpen(true);
  };

  const openReportBug = () => {
    setMode("bug");
    setIsOpen(true);
  };

  const openRequestFeature = () => {
    setMode("feature");
    setIsOpen(true);
  };

  const openRequestIntegration = () => {
    setMode("integration");
    setIsOpen(true);
  };

  const close = () => setIsOpen(false);

  const value = {
    openSupport,
    openReportBug,
    openRequestFeature,
    openRequestIntegration,
    close,
  };

  return (
    <SupportCenterContext.Provider value={value}>
      {children}
      <SupportCenterModal isOpen={isOpen} mode={mode} onClose={close} />
    </SupportCenterContext.Provider>
  );
};

export const useSupportCenter = () => useContext(SupportCenterContext);
